import "@babel/polyfill";
import "mutationobserver-shim";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router/index.js";
import store from "./store";
import { url, preffix, preffixFile, local } from "./components/common/common";
import { routerGo, getObjArr, arr } from "./router/import_router.js";
import "normalize.css/normalize.css";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import "@/styles/index.scss";
import "./components/index.js";
import axios from "axios";
import "vue-orgchart/dist/style.min.css";
import { Message } from "element-ui";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN"; // lang i18n
import JsonExcel from "vue-json-excel";
import VueViewer from "v-viewer";
import "viewerjs/dist/viewer.css";

import Form from "@/components/util/index.js";
Vue.use(Form);

import "./utils/directives.js";

import VueBus from "vue-bus";
Vue.use(VueBus);
Vue.component("downloadExcel", JsonExcel);
Vue.use(ElementUI, { locale });
Vue.use(VueViewer);
// svg-icon
import "@/icons";
import "./utils/rem.js";

import qs from "qs";

// 等保三级：接口报文加解密（请求拦截器加密 / 响应拦截器解密）
import { encryptRequest, decryptResponse } from "./utils/apiCrypto";

// 路由跳转进度条
NProgress.inc(0.5); //简单配置进度条
NProgress.configure({
  easing: "ease",
  speed: 500,
  showSpinner: false
});
var getRouter = null; //用来获取后台拿到的路由
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (!getRouter) {
    //第一次请求
    if (!getObjArr("router") && to.path != "/login") {
      //无路由
      // axios.get("/login/getShowMenu").then(res => {
      //   if (res.data.success && res.data.data && res.data.data.length) {
      //     getRouter = res.data.data; //拿到路由,存储路由到localStorage
      //     localStorage.setItem("router", JSON.stringify(getRouter));
      //     routerGo(to, next, getRouter); //执行路由跳转方法
      //   } else {
      //     //无权限
      //     next("/login");
      //   }
      // });
      //     axios.get(local + "/login/getShowMenu", headers: {{
      //       headers="{Authorization:token}",
      //     }

      // })

      axios
        .get(url + "/login/getShowMenu", {
          headers: {
            Authorization: window.localStorage.getItem("token")
          }
        })
        .then(res => {
          console.log("menu", res);
          if (res.data.success && res.data.data && res.data.data.length) {
            getRouter = res.data.data; //拿到路由,存储路由到localStorage
            localStorage.setItem("router", JSON.stringify(getRouter));
            routerGo(to, next, getRouter); //执行路由跳转方法
          } else {
            //无权限
            next("/login");
          }
        });
    } else if (to.path === "/login") {
      next();
    } else {
      //从localStorage拿到了路由
      getRouter = getObjArr("router"); //拿到路由
      routerGo(to, next, getRouter);
    }
  } else {
    next();
  }
  // console.log(to)
  // next()
  getShowOption(to.meta.code);
});

function getShowOption(code) {
  if (!code) {
    return;
  }
  axios
    .get(url + "/login/getShowOption", { params: { funcId: code } })
    .then(res => {
      // window.localStorage.setItem('Auths',JSON.stringify(['list']));
    });
}

router.afterEach(() => {
  NProgress.done();
});

// 所有请求调用处都已手动拼 url 前缀（如 $server + "/xxx" = /manager/xxx），
// 故 baseURL 不可再叠加 /manager，否则会出现 /manager/manager/xxx 双重前缀
axios.defaults.baseURL = "/";
axios.defaults.timeout = 30000;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

//  const request=axios.create({
//   baseURL:url,
//   timeout:5000,
//   headers:{
//     'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8',
//   }
//  })
Vue.prototype.$axios = axios;
//  设置请求拦截器和响应拦截器
axios.interceptors.request.use(
  config => {
    config.headers.common["Authorization"] = window.localStorage.getItem(
      "token"
    );
    // 等保三级：接口报文加密（每次请求随机 AES 密钥，RSA 公钥包裹传输）
    return encryptRequest(config);
  },
  err => {
    return Promise.reject(err);
  }
);

axios.interceptors.response.use(
  response => {
    // 等保三级：接口响应解密（还原明文 JSON 后走原有 code 判断逻辑，-1000 跳登录等不受影响）
    decryptResponse(response);
    if (response.data.code == "-1001") {
      // Message({
      //   message: response.data.message,
      //   type: 'error',
      // })
    }
    if (response.data.code == "-1000") {
      router.push({ path: "/login" });
    }
    return response;
  },
  err => {
    return Promise.reject(err);
  }
);

// import config from '../config'
// import vueLoaderConf from '../build/vue-loader.conf'

function deepClone(source) {
  const targetObj = source.constructor === Array ? [] : {}; // 判断复制的目标是数组还是对象
  for (let keys in source) {
    // 遍历目标
    if (source.hasOwnProperty(keys)) {
      if (source[keys] && typeof source[keys] === "object") {
        // 如果值是对象，就递归一下
        targetObj[keys] = source[keys].constructor === Array ? [] : {};
        targetObj[keys] = deepClone(source[keys]);
      } else {
        // 如果不是，就直接赋值
        targetObj[keys] = source[keys];
      }
    }
  }
  return targetObj;
}

Vue.config.productionTip = false;
Vue.prototype.$server = url;
Vue.prototype.$qs = qs;
Vue.prototype.$preffix = preffix;
Vue.prototype.$preffixFile = preffixFile;
Vue.prototype.$deepClone = deepClone;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js